<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <!-- EXTINTOR Y VALIZAS -->
      <div v-if="isFieldVisible('photo_fire_extinguisher_file')" class="mt-3">
        <div>
          <div class="form-group bordered col-md-4">
            <label for="photo_fire_extinguisher_file" class="form-label text-left">{{ getFieldDescription('photo_fire_extinguisher_file') }}</label>
          </div>
          <div>  
          <div>
            <div @click="openCamera('photo_fire_extinguisher_file')" class="btn btn-custom">
              <i class="bi bi-camera-fill"></i> Tomar fotografía
            </div>
            <input
              type="file"
              accept="image/*"
              capture="camera"
              class="form-control inputfile"
              :name="'photo_fire_extinguisher_file'"
              :id="'photo_fire_extinguisher_file'"
              style="display: none;"
              @change="onFileChange('photo_fire_extinguisher_file')"
            />
          </div>
        </div>
        <div class="btn tbn-block btn-custom mt-3" v-if="photo_fire_extinguisher_file" @click="openImageModal(photo_fire_extinguisher_file)">Ver Imagen</div>
      </div>
      <hr class="custom-hr mt-4 col-md-12" />
    </div>
    </div>
  </div>
    
  <!-- MODAL -->
  <ShowImagesModal
  :modalId="'imageModalPhotoFireExtinguisher'"
  :currentImage="currentImage"
  :currentImageName="currentImageName"
  />
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import ShowImagesModal from '../../modals/ShowImages';
import ImageCompressor from 'image-compressor.js'; 
import { rotateImageIfNeeded } from '../../../Utils/imageUtils'; 

export default {
  name: 'FormPhotoFireExtinguisher',
  props: {
    data: Object,
  },
  components: {
    ShowImagesModal,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const currentImage = ref(null);
    const currentImageName = ref('');

    const photo_fire_extinguisher_file = ref(null);

    const formData = reactive({
      photo_fire_extinguisher_id: null,
    });

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const cargarDatos = () => {
      try {
        showComponentData.value = dataCompany.value && dataCompany.value.photo_fire_extinguisher_file;
      } catch (error) {
        console.error(error);
      }
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalPhotoFireExtinguisher').modal('show');
    };

    const openCamera = (fieldName) => {
      const inputElement = document.getElementById(fieldName);
      inputElement.click();
    };

    const onFileChange = async (fieldName) => {
      const fileFields = {
        photo_fire_extinguisher_file: photo_fire_extinguisher_file,
      };

      const fileInput = document.getElementById(fieldName);

      try {
        const rotatedFile = await rotateImageIfNeeded(fileInput.files[0], 90);
        const compressedFile = await compressImage(rotatedFile);
        fileFields[fieldName].value = compressedFile;
        emitFieldChanged();
      } catch (error) {
        console.error('Error al comprimir la imagen:', error);
      }
    };

    const compressImage = (file) => {
      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor();
        compressor.compress(file, {
          maxWidth: 800,
          maxHeight: 600,
          quality: 1,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result);
          },
          error(error) {
            reject(error);
          },
        });
      });
    };

    const emitFieldChanged = () => {
      emit('formDataChanged', {
        photo_fire_extinguisher_id: photo_fire_extinguisher_file.value,
      });
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      openImageModal,
      onFileChange,
      currentImage,
      currentImageName,
      emitFieldChanged,
      openCamera,
      formData,
      photo_fire_extinguisher_file,
    };
  },
};
</script>

